module.exports = __webpack_public_path__ + "img/album07_23.736c0835.jpg";